<template>
  <section class="block-lg block-lg--border">
    <h2 class="headline-lg center">{{ $t('home.allInOne.allInOne') }}</h2>
    <div class="badge-card-list">
      <div
        class="badge-card badge-card--lg"
        v-for="item in list"
        :key="item"
      >
        <div class="badge-card__icon">
          <img
            :src="getMetaGlobOfAssetsSvg[item.icon].default"
            alt=""
            class="img img--contain"
          >
        </div>
        <p class="body-1">
          {{ item.text }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      list: [
        {
          icon: '/assets/images/svg/Approved-report.svg',
          text: this.$t('home.allInOne.discover')
        },
        {
          icon: '/assets/images/svg/Training.svg',
          text: this.$t('home.allInOne.showcase')
        },
        {
          icon: '/assets/images/svg/Financial-advisor-online.svg',
          text: this.$t('home.allInOne.provide')
        },
        {
          icon: '/assets/images/svg/Web-designer_2.svg',
          text: this.$t('home.allInOne.complaint')
        }
      ]
    }
  },
  computed: {
    getMetaGlobOfAssetsSvg() {
      return import.meta.glob('/assets/images/svg/*.svg', { eager: true })
    }
  },
}
</script>